// Unpublished Work © 2026 Deere & Company.

import {queryOptions} from '@tanstack/react-query';
import {getSelectedOrganizations} from '../services/selectedOrganizations';

export const selectedOrganizationsQueryOptions = queryOptions({
    queryKey: ['SelectedOrganizations'],
    queryFn: ({signal}) => getSelectedOrganizations(signal),
    staleTime: Infinity,
});
